import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'formly-field-ng-select',
  template: `
    <ng-select
      [formControl]="formControl"
      [formlyAttributes]="field"
      [multiple]="props.multiple"
      [closeOnSelect]="props.closeOnSelect"
      [placeholder]="props.placeholder"
      [selectableGroup]="props.selectableGroup"
      [selectableGroupAsModel]="props.selectableGroupAsModel"
      [hideSelected]="props.hideSelected"
      [groupBy]="props.groupBy"
      [required]="props.required"
      [readonly]="props.readonly"
      [clearable]="props.clearable ? true : false"
      (remove)="props.onRemove ? props.onRemove($event) : undefined"
      [items]="props.options || []"
      [bindLabel]="props.bindLabel || 'label'"
      [bindValue]="props.bindValue || 'id'"
    >
      <ng-template ng-optgroup-tmp let-item="item">
        {{ item[props.bindLabel || 'label'] || 'No group' }}
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        {{item[props.bindLabel || 'label']}}
      </ng-template>
    </ng-select>
    <ng-container *ngIf="props.onChangeMessage && formControl.touched">
      <small class="mt-3 d-block text-muted">{{props.onChangeMessage}}</small>
    </ng-container>
  `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldNgSelect extends FieldType {}
